import { Controller, useFormContext } from "react-hook-form";

import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export interface ISetting {
    name: string;
    title: string;
    description: string;
}

interface IProps extends ISetting {
    isLoading?: boolean;
}

export const Setting = ({
    name,
    title,
    description,
    isLoading = false,
}: IProps) => {
    const { control } = useFormContext();

    return (
        <div className="bg-card flex w-full items-center justify-between gap-4 rounded-lg border p-4">
            <div className="flex flex-col gap-0.5">
                <Label htmlFor={name} className="text-sm font-medium">
                    {title}
                </Label>
                <p className="text-muted-foreground text-sm">{description}</p>
            </div>

            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <Switch
                        id={name}
                        checked={!!field.value}
                        onCheckedChange={field.onChange}
                        disabled={isLoading}
                        aria-label={title}
                    />
                )}
            />
        </div>
    );
};
